import { MultiSelect } from '../inputs'
import { useGuides } from '../../hooks/useGuides'
import { useModal } from '../../context/ModalContext'
import './guides.css'

// Attach reusable guides to an entity: a multiselect of the user's guides plus a
// "New guide" button that opens the guide form and auto-selects the created guide.
// `value` is an array of guide objects; `onChange` receives the next array.
export function GuidePicker({ value = [], onChange, label = 'Guides' }) {
  const { guides, upsertGuide } = useGuides()
  const { openModal } = useModal()

  const openNew = () => {
    openModal('guide-form', {
      onSaved: (guide) => {
        if (!guide) return
        upsertGuide(guide)
        onChange([...(value || []), guide])
      },
    })
  }

  return (
    <div className="guide-picker">
      <div className="guide-picker-head">
        <span className="guide-picker-label">{label}</span>
        <button type="button" className="guide-picker-new" onClick={openNew}>
          + New guide
        </button>
      </div>
      <MultiSelect
        value={value}
        onChange={onChange}
        options={guides}
        getOptionValue={(g) => g._id}
        getOptionLabel={(g) => g.title || g.name || 'Guide'}
        placeholder="Attach guides…"
      />
    </div>
  )
}

export default GuidePicker
